import React from "react";
import { Button } from "reactstrap";
import { FaEdit, FaRegTrashAlt, FaTrash } from "react-icons/fa";
import Styles from "../../pages/homework/assets/Form.module.css";
import grp713 from "../../pages/homework/assets/images/Group 713.png";
import delete1 from "../../pages/homework/assets/images/delete.png";
const ActionButtons = ({
  onEdit,
  onDelete,
  showEdit = true,
  showDelete = true,
}) => {
  

 

  return (
  <div className="d-flex justify-content-center gap-2">
     <div className={`${Styles.edit_code}`}>

      {showEdit && (
        <Button className={Styles.edit_code}  onClick={onEdit}>
          <img src={grp713} alt="Edit" width={20} />
          Edit
        </Button>
      )}
     </div>
      {showDelete && (
         <div
                                className={`${Styles.delete_button_code} me-2 mx-2`}
                              >
        <Button className={Styles.delete_button_code}  onClick={onDelete}>
          <img src={delete1} alt="Delete" width={20}  className={`${Styles.delete_icon}`}/>
          Delete
        </Button>
                                </div>
      )}
    </div>
  );
};

export default ActionButtons;